"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Breadcrumbs = require("./Breadcrumbs.styles");

var Breadcrumbs = function Breadcrumbs(_ref) {
  var className = _ref.className,
      _ref$home = _ref.home,
      home = _ref$home === void 0 ? {
    href: '/',
    label: 'Home',
    show: true
  } : _ref$home,
      items = _ref.items,
      mobileView = _ref.mobileView;
  var homeHref = home.href,
      homeLabel = home.label,
      showHome = home.show;
  var position = showHome ? 2 : 1;
  return /*#__PURE__*/_react["default"].createElement(_Breadcrumbs.StyledBreadcrumbs, {
    className: className,
    itemScope: true,
    itemType: "http://schema.org/BreadcrumbList",
    mobileView: mobileView
  }, showHome && /*#__PURE__*/_react["default"].createElement("li", {
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "/"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: homeHref,
    itemProp: "item"
  }, homeLabel), /*#__PURE__*/_react["default"].createElement("meta", {
    itemProp: "position",
    content: "1"
  })), items && items.map(function (_ref2, index) {
    var href = _ref2.href,
        name = _ref2.name;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (0, _nanoid.nanoid)(),
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "http://schema.org/ListItem"
    }, href ? /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      itemProp: "item"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      itemProp: "name"
    }, name)) : /*#__PURE__*/_react["default"].createElement("span", {
      itemProp: "name"
    }, name), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "position",
      content: position + index
    }));
  }));
};

Breadcrumbs.defaultProps = {
  className: null,
  items: null,
  mobileView: 'previousLevel',
  home: undefined
};
Breadcrumbs.propTypes = {
  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Items that will populate the breadcrumb */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    href: _propTypes.string,
    name: _propTypes.string.isRequired
  })),

  /** First item of the breadcrumb */
  home: (0, _propTypes.shape)({
    /** First level link */
    href: _propTypes.string,

    /** Label of the first level of the breadcrumb */
    label: _propTypes.string,

    /** Determines if first level "Home" should be displayed */
    show: _propTypes.bool
  }),

  /** Determines type of view for mobile devices */
  mobileView: (0, _propTypes.oneOf)(['inline', 'hidden', 'previousLevel', 'wrap'])
};
Breadcrumbs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Breadcrumbs",
  "props": {
    "home": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "First item of the breadcrumb",
      "type": {
        "name": "shape",
        "value": {
          "href": {
            "name": "string",
            "description": "First level link",
            "required": false
          },
          "label": {
            "name": "string",
            "description": "Label of the first level of the breadcrumb",
            "required": false
          },
          "show": {
            "name": "bool",
            "description": "Determines if first level \"Home\" should be displayed",
            "required": false
          }
        }
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "items": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Items that will populate the breadcrumb",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "href": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": true
            }
          }
        }
      },
      "required": false
    },
    "mobileView": {
      "defaultValue": {
        "value": "'previousLevel'",
        "computed": false
      },
      "description": "Determines type of view for mobile devices",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'inline'",
          "computed": false
        }, {
          "value": "'hidden'",
          "computed": false
        }, {
          "value": "'previousLevel'",
          "computed": false
        }, {
          "value": "'wrap'",
          "computed": false
        }]
      },
      "required": false
    }
  }
};
var _default = Breadcrumbs;
exports["default"] = _default;